import React from 'react';
import {
  useParams,
} from 'react-router-dom';
import CommentForm from '../components/comment-form';
import Layout from '../components/layout';
import LinkButton from '../components/link-button';
import PageHeader from '../components/page-header';
import './page.css';

const CommentPage = () => {
  const { id } = useParams();

  return (
    <Layout>
      <div className="page">
        <PageHeader
          title={`${id ? 'Modifier' : 'Créer'} un commentaire`}
        />

        <div className="page_actions">
          <LinkButton
            className="page_action-button"
            icon="arrow_back"
            label="Retour"
            to="/commentaires"
            theme="danger"
          />
        </div>

        <CommentForm id={parseInt(id, 10)} />
      </div>
    </Layout>
  );
};

export default CommentPage;
